<template>
  <section class="mb-20">
    <div class="text-center mb-12">
      <h2 class="text-3xl font-bold text-gray-900 mb-4">六维度RIASEC职业兴趣模型</h2>
      <p class="text-lg text-gray-600 max-w-2xl mx-auto">
        从六个核心维度深度分析你的职业兴趣，精准计算Holland Code
      </p>
    </div>

    <div class="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
      <!-- 实际型 -->
      <div class="card text-center hover:shadow-xl transition-all hover:-translate-y-1 border-2 border-red-100">
        <div class="p-6">
          <div class="text-5xl mb-3">🔧</div>
          <h3 class="font-semibold mb-2 text-lg text-red-600">实际型 (R)</h3>
          <p class="text-sm text-gray-600">
            喜欢使用工具、机器进行实际操作
          </p>
          <div class="mt-3 text-xs text-gray-500">
            <div>典型职业：工程师、技工</div>
            <div>建筑师、机械师</div>
          </div>
        </div>
      </div>

      <!-- 研究型 -->
      <div class="card text-center hover:shadow-xl transition-all hover:-translate-y-1 border-2 border-purple-100">
        <div class="p-6">
          <div class="text-5xl mb-3">🔬</div>
          <h3 class="font-semibold mb-2 text-lg text-purple-600">研究型 (I)</h3>
          <p class="text-sm text-gray-600">
            喜欢观察、学习、研究和分析
          </p>
          <div class="mt-3 text-xs text-gray-500">
            <div>典型职业：科学家、研究员</div>
            <div>医生、数据分析师</div>
          </div>
        </div>
      </div>

      <!-- 艺术型 -->
      <div class="card text-center hover:shadow-xl transition-all hover:-translate-y-1 border-2 border-amber-100">
        <div class="p-6">
          <div class="text-5xl mb-3">🎨</div>
          <h3 class="font-semibold mb-2 text-lg text-amber-600">艺术型 (A)</h3>
          <p class="text-sm text-gray-600">
            喜欢创造性的表达和艺术活动
          </p>
          <div class="mt-3 text-xs text-gray-500">
            <div>典型职业：艺术家、设计师</div>
            <div>作家、音乐家</div>
          </div>
        </div>
      </div>

      <!-- 社会型 -->
      <div class="card text-center hover:shadow-xl transition-all hover:-translate-y-1 border-2 border-cyan-100">
        <div class="p-6">
          <div class="text-5xl mb-3">👥</div>
          <h3 class="font-semibold mb-2 text-lg text-cyan-600">社会型 (S)</h3>
          <p class="text-sm text-gray-600">
            喜欢帮助、教导、服务他人
          </p>
          <div class="mt-3 text-xs text-gray-500">
            <div>典型职业：教师、心理咨询师</div>
            <div>护士、社会工作者</div>
          </div>
        </div>
      </div>

      <!-- 企业型 -->
      <div class="card text-center hover:shadow-xl transition-all hover:-translate-y-1 border-2 border-green-100">
        <div class="p-6">
          <div class="text-5xl mb-3">💼</div>
          <h3 class="font-semibold mb-2 text-lg text-green-600">企业型 (E)</h3>
          <p class="text-sm text-gray-600">
            喜欢领导、说服、影响他人
          </p>
          <div class="mt-3 text-xs text-gray-500">
            <div>典型职业：企业家、销售经理</div>
            <div>律师、市场总监</div>
          </div>
        </div>
      </div>

      <!-- 传统型 -->
      <div class="card text-center hover:shadow-xl transition-all hover:-translate-y-1 border-2 border-blue-100">
        <div class="p-6">
          <div class="text-5xl mb-3">📊</div>
          <h3 class="font-semibold mb-2 text-lg text-blue-600">传统型 (C)</h3>
          <p class="text-sm text-gray-600">
            喜欢有序、系统、结构化的活动
          </p>
          <div class="mt-3 text-xs text-gray-500">
            <div>典型职业：会计师、行政人员</div>
            <div>图书管理员、文员</div>
          </div>
        </div>
      </div>
    </div>

    <!-- 计算方法说明 -->
    <div class="mt-12 max-w-3xl mx-auto bg-gradient-to-r from-psychology-calm to-psychology-warm rounded-2xl p-8 border border-psychology-primary-20">
      <div class="flex items-start gap-4">
        <div class="text-4xl">🎯</div>
        <div>
          <h3 class="text-xl font-bold text-gray-800 mb-2">科学的Holland Code计算模型</h3>
          <p class="text-gray-600 leading-relaxed">
            我们基于<strong>John Holland教授的RIASEC理论</strong>，综合六个维度的得分计算你的Holland Code。
            每个维度得分范围0-100分，按得分从高到低排序，取前3个字母组成你的职业兴趣代码（如RIA、SEC等），
            精准评估你的<strong>职业兴趣类型</strong>并为你推荐<strong>适合的专业方向</strong>。
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'DimensionsSection'
}
</script>

<style scoped>
.card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}
</style>
